import React from "react";
import "./Schedule.scss";
import FadeInSection from "./FadeInSection";

function Schedule() {
  return (
    <div className="bg-schedule">
      <div className="timeline p-top-8 p-bottom-8">
        <FadeInSection>
          <div className="timeline-container left">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <i className="fa-solid fa-utensils m-right-1 text-xl" />
                <span className="text-primary">12:00</span>
              </h2>
              <h3 className="m-bottom-1">Ресторант "Стария Чинар"</h3>
              <p className="m-bottom-1">
              Очакваме ви на пристанище Порт Варна в „Стария Чинар“! Елате гладни и в добро настроение – всичко останало е осигурено!  
              </p>
              <a className="see-more m-top-2 text-primary" href="#transport">
                Виж повече
              </a>
            </div>
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-0"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-12"></div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container right">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <i className="fa-solid fa-bullhorn m-right-1 text-xl"></i>
                <span className="text-primary">15:00</span>
              </h2>
              <h3 className="m-bottom-1">Изпращане</h3>
              <p className="m-bottom-1">
                Подгответе се да броим заедно, за да сме сигурни, че изпращането на абитуриента е по план – без неразбрали!
              </p>
            </div>
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-0"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-15"></div>
            </div>
          </div>
        </FadeInSection>
      </div>
    </div>
  );
}

export default Schedule;
